import {
  AccountBalance as AccountBalanceIcon,
  Campaign as CampaignIcon,
  AccountTree as AccountTreeIcon,
  Archive as ArchiveIcon,
  Assessment as AssessmentIcon,
  AssignmentReturn as AssignmentReturnIcon,
  AssignmentReturned as AssignmentReturnedIcon,
  BiotechRounded as BiotechRoundedIcon,
  Business as BusinessIcon,
  CallReceived as CallReceivedIcon,
  Category as CategoryIcon,
  ColorLens as ColorLensIcon,
  Dashboard as DashboardIcon,
  Description as DescriptionIcon,
  EmojiEmotionsRounded as EmojiEmotionsRoundedIcon,
  Group as GroupIcon,
  Hail as HailIcon,
  Inventory as InventoryIcon,
  LensBlur as LensBlurIcon,
  LocalOffer as LocalOfferIcon,
  LocalShipping as LocalShippingIcon,
  Payments as PaymentsIcon,
  PointOfSale as PointOfSaleIcon,
  Receipt as ReceiptIcon,
  RequestQuote as RequestQuoteIcon,
  Rule as RuleIcon,
  Savings as SavingsIcon,
  ScatterPlot as ScatterPlotIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  Tune as TuneIcon,
  ShoppingBag as ShoppingBagIcon,
  ShoppingCart as ShoppingCartIcon,
  Store as StoreIcon,
  Summarize as SummarizeIcon,
  SwapHoriz as SwapHorizIcon,
  TableView as TableViewIcon,
  VolunteerActivism as VolunteerActivismIcon,
  Warehouse as WarehouseIcon,
} from "@mui/icons-material";

import { PermissionEnum } from "./features/permissions";

export const NAVIGATION = [
  {
    segment: "dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    segment: "setting",
    title: "Pengaturan",
    icon: <SettingsIcon />,
    children: [
      {
        segment: "users",
        title: "Pengguna",
        icon: <GroupIcon />,
        permission: PermissionEnum.READ_USERS,
      },
      {
        segment: "roles",
        title: "Peran",
        icon: <SecurityIcon />,
        permission: PermissionEnum.READ_ROLES,
      },
      {
        segment: "companies",
        title: "Perusahaan",
        icon: <BusinessIcon />,
        permission: PermissionEnum.READ_COMPANIES,
      },
      {
        segment: "outlets",
        title: "Cabang Toko",
        icon: <StoreIcon />,
        permission: PermissionEnum.READ_OUTLETS,
      },
      {
        segment: "accounting",
        title: "Akuntansi",
        icon: <AccountBalanceIcon />,
        children: [
          {
            segment: "preferences",
            title: "Preferensi Akun",
            icon: <TuneIcon />,
            permission:
              PermissionEnum.READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES,
          },
          {
            segment: "default-accounts",
            title: "Akun Default",
            icon: <RuleIcon />,
            permission:
              PermissionEnum.READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT,
          },
        ],
      },
      {
        segment: "promotion-campaigns",
        title: "Kampanye Promosi",
        icon: <CampaignIcon />,
        permission: PermissionEnum.READ_PROMOTIONS,
      },
      {
        segment: "promotions",
        title: "Promosi",
        icon: <LocalOfferIcon />,
        permission: PermissionEnum.READ_PROMOTIONS,
      },
    ],
  },
  {
    segment: "expense",
    title: "Biaya",
    icon: <ReceiptIcon />,
    children: [
      {
        segment: "expenses",
        title: "Biaya",
        icon: <ReceiptIcon />,
        permission: PermissionEnum.READ_EXPENSES,
      },
      {
        segment: "expense-accruals",
        title: "Pencatatan Beban",
        icon: <RequestQuoteIcon />,
        permission: PermissionEnum.READ_EXPENSE_ACCRUALS,
      },
      {
        segment: "expense-categories",
        title: "Kategori Biaya",
        icon: <TableViewIcon />,
        permission: PermissionEnum.READ_EXPENSE_CATEGORIES,
      },
    ],
  },
  {
    title: "Persediaan",
    segment: "inventory",
    icon: <InventoryIcon />,
    children: [
      {
        segment: "products",
        title: "Produk Umum",
        icon: <InventoryIcon />,
        permission: PermissionEnum.READ_PRODUCTS,
      },
      {
        segment: "lens-products",
        title: "Produk Lensa",
        icon: <InventoryIcon />,
        permission: PermissionEnum.READ_PRODUCTS,
      },
      {
        segment: "product-categories",
        title: "Kategori Produk",
        icon: <CategoryIcon />,
        permission: PermissionEnum.READ_PRODUCT_CATEGORIES,
      },
      {
        segment: "product-variant-attributes",
        title: "Varian Attribut",
        icon: <ColorLensIcon />,
        permission: PermissionEnum.READ_PRODUCT_VARIANT_ATTRIBUTES,
      },
      {
        segment: "unit-of-measurements",
        title: "Satuan Ukuran",
        icon: <ScatterPlotIcon />,
        permission: PermissionEnum.READ_UNIT_OF_MEASUREMENTS,
      },
      {
        segment: "warehouses",
        title: "Gudang",
        icon: <WarehouseIcon />,
        permission: PermissionEnum.READ_WAREHOUSES,
      },
      {
        segment: "warehouse-stocks",
        title: "Stok Gudang",
        icon: <WarehouseIcon />,
        permission: PermissionEnum.READ_WAREHOUSES,
      },
      {
        segment: "stock-adjustments",
        title: "Penyesuaian Stok",
        icon: <SwapHorizIcon />,
        permission: PermissionEnum.READ_STOCK_ADJUSTMENTS,
      },
    ],
  },
  {
    title: "Pembelian",
    segment: "procurement",
    icon: <ShoppingCartIcon />,
    children: [
      {
        segment: "purchase-orders",
        title: "Pesanan Pembelian",
        icon: <ShoppingBagIcon />,
        children: [
          {
            segment: "standard",
            title: "Bulk",
            icon: <ShoppingBagIcon />,
            permission: PermissionEnum.READ_PURCHASE_ORDERS_STANDARD,
          },
          {
            segment: "lab",
            title: "Laboratorium",
            icon: <BiotechRoundedIcon />,
            permission: PermissionEnum.READ_PURCHASE_ORDERS_LAB,
          },
          {
            segment: "lab-inverted",
            title: "Lensa Pre-Order",
            icon: <LensBlurIcon />,
            permission: PermissionEnum.READ_PURCHASE_ORDERS_LAB,
          },
        ],
      },
      {
        segment: "purchase-down-payments",
        title: "Uang Muka Pembelian",
        icon: <SavingsIcon />,
        permission: PermissionEnum.READ_PURCHASE_DOWN_PAYMENTS,
      },
      {
        segment: "goods-receipts",
        title: "Penerimaan Barang",
        icon: <ArchiveIcon />,
        permission: PermissionEnum.READ_GOODS_RECEIPTS,
      },
      {
        // Grouping only — no segment, so the children keep their existing URLs.
        title: "Faktur",
        icon: <ReceiptIcon />,
        children: [
          {
            segment: "purchase-invoices",
            title: "Faktur Pembelian",
            icon: <ReceiptIcon />,
            permission: PermissionEnum.READ_PURCHASE_INVOICES,
          },
          {
            segment: "incoming-sales-invoices",
            title: "Faktur dari Penjual",
            icon: <CallReceivedIcon />,
            // What the endpoint itself enforces; the convert action is gated on
            // CREATE_PURCHASE_INVOICES inside the page.
            permission: PermissionEnum.READ_SALES_INVOICES,
            badge: "incomingSalesInvoices",
          },
        ],
      },
      {
        segment: "purchase-payments",
        title: "Pembayaran Pembelian",
        icon: <RequestQuoteIcon />,
        permission: PermissionEnum.READ_PURCHASE_PAYMENTS,
      },
      {
        segment: "purchase-returns",
        title: "Retur Pembelian",
        icon: <AssignmentReturnIcon />,
        permission: PermissionEnum.READ_PURCHASE_RETURNS,
      },
      {
        segment: "suppliers",
        title: "Pemasok",
        icon: <HailIcon />,
        permission: PermissionEnum.READ_SUPPLIERS,
      },
      {
        segment: "supplier-categories",
        title: "Kategori Pemasok",
        icon: <CategoryIcon />,
        permission: PermissionEnum.READ_SUPPLIER_CATEGORIES,
      },
      {
        segment: "payment-terms",
        title: "Syarat Pembayaran",
        icon: <PaymentsIcon />,
        permission: PermissionEnum.READ_PAYMENT_TERMS,
      },
    ],
  },
  {
    title: "Penjualan",
    segment: "sales",
    icon: <PointOfSaleIcon />,
    children: [
      {
        segment: "sales-requests",
        title: "Permintaan Penjualan",
        icon: <VolunteerActivismIcon />,
        permission: PermissionEnum.READ_SALES_REQUESTS,
      },
      {
        segment: "sales-orders",
        title: "Pesanan Penjualan",
        icon: <PointOfSaleIcon />,
        permission: PermissionEnum.READ_SALES_ORDERS,
      },
      {
        segment: "sales-down-payments",
        title: "Uang Muka Penjualan",
        icon: <SavingsIcon />,
        permission: PermissionEnum.READ_SALES_DOWN_PAYMENTS,
      },
      {
        segment: "delivery-orders",
        title: "Pengiriman Penjualan",
        icon: <LocalShippingIcon />,
        permission: PermissionEnum.READ_DELIVERY_ORDERS,
      },
      {
        segment: "sales-invoices",
        title: "Faktur Penjualan",
        icon: <ReceiptIcon />,
        permission: PermissionEnum.READ_SALES_INVOICES,
      },
      {
        // Grouping only — no segment, so the children keep their existing
        // top-level URLs (/sales/sales-payments, /sales/incoming-purchase-payments).
        title: "Penerimaan",
        icon: <RequestQuoteIcon />,
        children: [
          {
            segment: "sales-payments",
            title: "Penerimaan Penjualan",
            icon: <RequestQuoteIcon />,
            permission: PermissionEnum.READ_SALES_PAYMENTS,
          },
          {
            segment: "incoming-purchase-payments",
            title: "Pembayaran dari Pembeli",
            icon: <CallReceivedIcon />,
            // What the endpoint itself enforces; the convert action is gated on
            // CREATE_SALES_PAYMENTS inside the page.
            permission: PermissionEnum.READ_PURCHASE_PAYMENTS,
            badge: "incomingPurchasePayments",
          },
        ],
      },
      {
        // Grouping only — no segment, so the children keep their existing
        // top-level URLs (/sales/sales-returns, /sales/incoming-purchase-returns).
        title: "Retur",
        icon: <AssignmentReturnIcon />,
        children: [
          {
            segment: "sales-returns",
            title: "Retur Penjualan",
            icon: <AssignmentReturnedIcon />,
            permission: PermissionEnum.READ_SALES_RETURNS,
          },
          {
            segment: "incoming-purchase-returns",
            title: "Retur dari Pembeli",
            icon: <CallReceivedIcon />,
            permission: PermissionEnum.READ_PURCHASE_RETURNS,
            badge: "incomingPurchaseReturns",
          },
        ],
      },
      {
        segment: "customer-claims",
        title: "Klaim Pelanggan",
        icon: <SummarizeIcon />,
        children: [
          {
            segment: "receive",
            title: "Terima Barang",
            icon: <CallReceivedIcon />,
            permission: PermissionEnum.READ_CUSTOMER_CLAIMS,
          },
          {
            segment: "delivery",
            title: "Kirim Barang",
            icon: <LocalShippingIcon />,
            permission: PermissionEnum.READ_CUSTOMER_CLAIMS,
          },
        ],
      },
      {
        segment: "sales-order-default-general-product-variants",
        title: "Default Produk Umum",
        icon: <InventoryIcon />,
        permission: PermissionEnum.READ_PRODUCTS,
      },
      {
        segment: "payment-methods",
        title: "Metode Pembayaran",
        icon: <PaymentsIcon />,
        permission: PermissionEnum.READ_PAYMENT_METHODS,
      },
      {
        segment: "customers",
        title: "Pelanggan",
        icon: <EmojiEmotionsRoundedIcon />,
        permission: PermissionEnum.READ_CUSTOMERS,
      },
    ],
  },
  {
    title: "Buku Besar",
    segment: "general-ledger",
    icon: <AccountBalanceIcon />,
    children: [
      {
        segment: "chart-of-accounts",
        title: "Template Akun Perkiraan",
        icon: <AccountTreeIcon />,
        permission: PermissionEnum.READ_CHART_OF_ACCOUNTS,
      },
      {
        segment: "outlet-chart-of-accounts",
        title: "Akun Perkiraan Outlet",
        icon: <AccountTreeIcon />,
        permission: PermissionEnum.READ_OUTLET_CHART_OF_ACCOUNTS,
      },
      {
        segment: "journal-vouchers",
        title: "Jurnal Umum",
        icon: <DescriptionIcon />,
        permission: PermissionEnum.READ_JOURNAL_VOUCHERS,
      },
      {
        segment: "other-payments",
        title: "Pembayaran",
        icon: <PaymentsIcon />,
        permission: PermissionEnum.READ_OTHER_PAYMENTS,
      },
      {
        segment: "trial-balance",
        title: "Neraca Percobaan",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_CHART_OF_ACCOUNTS,
      },
    ],
  },
  {
    title: "Laporan",
    segment: "report",
    icon: <AssessmentIcon />,
    children: [
      {
        segment: "sales-orders",
        title: "Lap. Penjualan",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_SALES_ORDER_REPORT,
      },
      {
        segment: "sales-order-payments",
        title: "Lap. Penerimaan",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_SALES_ORDER_PAYMENT_REPORT,
      },
      {
        segment: "expenses",
        title: "Lap. Biaya",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_EXPENSE_REPORT,
      },
      {
        segment: "sales-order-product-variants",
        title: "Lap. Varian Produk",
        icon: <SummarizeIcon />,
        children: [
          {
            segment: "retail",
            title: "Outlet Retail",
            icon: <SummarizeIcon />,
            permission: PermissionEnum.READ_SALES_ORDER_PRODUCT_REPORT,
          },
          {
            segment: "hub",
            title: "Outlet Hub",
            icon: <SummarizeIcon />,
            permission: PermissionEnum.READ_SALES_ORDER_PRODUCT_REPORT,
          },
        ],
      },
      {
        segment: "cost-of-goods-sold",
        title: "HPP",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_COST_OF_GOODS_SOLD_REPORT,
      },
      {
        segment: "inventory-value",
        title: "Nilai Persediaan",
        icon: <SummarizeIcon />,
        permission: PermissionEnum.READ_INVENTORY_VALUE_REPORT,
      },
    ],
  },
];
